import { FormHelperText, InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BlueInfoIcon, DesktopBlueIcon, DocBlueIcon, GreyLockIcon, GridSearchIcon, SearchButtonClearedIcon, WhiteTickIcon } from "../../icon";
import { FalkonEsignTemplateModel } from "../../models/templates.models";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { UtilityService } from "../../services/UtilityService";
import ButtonComponent from "../shared/button/button.component";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { validateForm } from "../shared/form-validation";
import { FalkonEsignTemplateService } from "../../services/FalkonEsignService";
import { UserService } from "../../services/UserService";
import { ProfileModel } from "../../models/profile.model";

interface Iprops {

    HandleClose: () => void;
    PhoneNumber: string;

}

const FalkonesignPopOverComponent: React.FC<Iprops> = (Props: Iprops) => {

    const Profile: ProfileModel = UserService.getCurrentUserFromLocalStorage();
    const OrgName = useSelector(selector.OrganizationName);
    const IsMobileDevice = useSelector(selector.isMobileDevice)

    const FalkonEsignTemplates: FalkonEsignTemplateModel[] = useSelector(selector.FalkonEsignTemplates);
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)

    const [currentStep, setCurrentStep] = useState<number>(1);

    const [searchTemplateText, setSearchTemplateText] = useState<string>("");
    const [templates, setTemplates] = useState(FalkonEsignTemplates.map(x => { return { ...x, Selected: false } }));
    const [selectedTemplate, setSelectedTemplate] = useState<{ ID: string, FileName: string }>();
    const [email, setEmail] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const [nameError, setNameError] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);


    useEffect(() => {
        setTemplates(FalkonEsignTemplates.map(x => { return { ...x, Selected: false } }))
    }, [FalkonEsignTemplates])

    const handleTemplateSelection = (temp: any) => {
        setTemplates(templates.map(x => { return { ...x, Selected: x.ID === temp.ID } }))
        setSelectedTemplate({ ID: temp.ID, FileName: temp.FileName })
    }

    const handleSearch = (val: string) => {
        setSearchTemplateText(val)
        if (!!val) {
            let sortedTemplates: FalkonEsignTemplateModel[] = []
            sortedTemplates = FalkonEsignTemplates.filter(x => x.FileName.toLocaleLowerCase().includes(val.toLocaleLowerCase()) || UtilityService.convertDateToDay(x.updatedAt).toLocaleLowerCase().includes(val.toLocaleLowerCase()))
            setTemplates(sortedTemplates.map(x => { return { ...x, Selected: x.ID === selectedTemplate?.ID } }))
        }
        else {
            setTemplates(FalkonEsignTemplates.map(x => { return { ...x, Selected: x.ID === selectedTemplate?.ID } }))
        }
    }

    const handleNext = () => {
        if (!selectedTemplate?.ID) {
            setToast("Please select a document", ToasterType.DANGER)
        }
        else {
            setCurrentStep(2)
        }
    }

    const handleEmailChange = (e) => {
        setEmail(e.target.value)
        validateForm({ ["email"]: e.target.value }, errors => {
            setEmailError(errors["email"])
        })
    }

    const handleNameChange = (e) => {
        setName(e.target.value)
        validateForm({ ["name"]: e.target.value }, errors => {
            setNameError(errors["name"])
        })
    }

    const HandleSubmit = () => {
        if (validateForm({ ["email"]: email, ["name"]: name }, errors => {
            setEmailError(errors["email"])
            setNameError(errors["name"])
        })) {
            setIsLoading(true)
            FalkonEsignTemplateService.sendFalkonEsignTemplateForSigning(selectedTemplate.ID, {
                first_name: Profile.FirstName,
                last_name: Profile.LastName,
                phone_number: Profile.PhoneNumber,
                phone_number_id: Profile.PhoneNumberID,
                organization_id: Profile.OrgId,
                organization_name: OrgName,
                recipients: [{ order_number: 1, email: email, phone_number: Props.PhoneNumber, name: name, type: "Email OTP" }]
            }).then((res) => {
                setIsLoading(false)
                Props.HandleClose();
                setToast("Secure signing link sent successfully", ToasterType.SUCCESS)
            }).catch((err) => {
                setIsLoading(false)
                Props.HandleClose();
                setToast("Sending secure signing link failed", ToasterType.DANGER)
            })

        }
    }


    return (
        <div className="w-p-100 h-p-100 o-hidden">
            {currentStep === 1 ?
                <>
                    <div className='mx-auto h5-semibold d-flex align-center h-p-15 w-p-100 bb-primary-divider-2'>
                        <div className="w-6 h-6 d-flex align-center justify-center mx-2 mb-1 br-3 bg-color-vigenary">
                            <DesktopBlueIcon className="w-3 h-3" />
                        </div>
                        <div className="">
                            <div className="h2-semibold">
                                Send for E-Sign
                            </div>
                            {!IsMobileDevice && <div className="h6-medium color-con-hist-msg-date">
                                Sending to {Props.PhoneNumber}
                            </div>
                            }
                        </div>
                        <div className="d-flex ml-auto align-center mr-4">

                            <div className={`w-3 h-3 br-3 mr-1 d-flex justify-center align-center bg-color-primary-light color-secondary`}>1</div>
                            <div className={`h4-medium mr-2 color-primary-accent`}>Select Template</div>

                            <div className={`w-3 h-3 br-3 mr-1 d-flex justify-center align-center bg-color-circular-bar-circle-notsent-circle-background color-secure-chat-login-pin`}>2</div>
                            <div className={`h4-medium color-secure-chat-login-pin`}>Send</div>
                        </div>
                    </div>
                    <div className='d-flex flex-direction w-p-100 h-p-72'>
                        <div className="w-p-100 h-p-12 max-h-10 d-flex align-flex-end justify-center">
                            <TextField
                                inputProps={{
                                    tabIndex: 4,
                                    "data-arrow-index": 200,
                                }}
                                fullWidth
                                placeholder={"Search template..."}
                                value={searchTemplateText}
                                onChange={(e) => { handleSearch(e.target.value) }}
                                variant="filled"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment
                                            position="start"
                                            sx={{
                                                height: "2.5rem",
                                                maxHeight: "2.5rem",
                                                alignItems: "center",
                                                marginTop: "0 !important",
                                            }}
                                        >
                                            <GridSearchIcon
                                                className="d-flex"
                                                style={{
                                                    width: "1.375rem",
                                                    height: "1.375rem",
                                                    flexShrink: 0,
                                                }}
                                            />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        searchTemplateText && (
                                            <InputAdornment
                                                position="end"
                                                sx={{
                                                    height: "2.5rem",
                                                    maxHeight: "2.5rem",
                                                    alignItems: "center",
                                                    margin: 0,
                                                }}
                                            >
                                                <button
                                                    type="button"
                                                    className="d-flex align-center c-pointer p-0 b-none bg-transparent"
                                                    onClick={() => handleSearch("")}
                                                    aria-label="Clear search"
                                                >
                                                    <SearchButtonClearedIcon
                                                        style={{
                                                            width: "1.375rem",
                                                            height: "1.375rem",
                                                            display: "block",
                                                        }}
                                                    />
                                                </button>
                                            </InputAdornment>
                                        )
                                    ),
                                    disableUnderline: true
                                }}
                                size="small"
                                className="my-auto max-h-5 d-flex align-center flex-grow-1 br-2 custom-text-field-border mx-2 mt-1 bg-color-nav-bar-mobile"
                                sx={{
                                    flex: "1 1 0%",
                                    minWidth: 0,
                                    maxWidth: "100%",
                                    maxHeight: "2.5rem",
                                    alignSelf: "center",
                                    "& .MuiFilledInput-root": {
                                        width: "100%",
                                        maxHeight: "2.5rem",
                                        minHeight: 0,
                                        alignItems: "center",
                                        borderRadius: "0.5rem",
                                        backgroundColor: "#f9fafb",
                                    },
                                    "& .MuiInputBase-input": {
                                        py: "6px",
                                        boxSizing: "border-box",
                                    },
                                    "& .MuiInputAdornment-root": {
                                        maxHeight: "2.5rem",
                                        height: "2.5rem",
                                        alignItems: "center",
                                    },
                                }}
                            />
                        </div>
                        <div className="h-p-88 d-flex flex-direction o-y-scroll">
                            {
                                templates.map(x => {
                                    return <div className={`flex-1 ml-2 mr-1 min-h-8 max-h-8 br-3 ${x.Selected ? "border-primary-light bg-color-ai-analytics-box-info-status" : "page-not-found-border"} d-flex mt-1 align-center c-pointer`} onClick={() => handleTemplateSelection(x)}>
                                        <div className={` w-2 h-2 br-4 ${x.Selected ? "bg-color-primary-light" : "page-not-found-border"} mx-2 color-secondary d-flex justify-center align-center`}>
                                            ⬤
                                        </div>
                                        <div className={`w-4 h-4 d-flex align-center justify-center mr-2 br-2 ${IsDarkMode ? "bg-color-vigenary" : "bg-color-con-hist-outbound-msg-bg"}`}>
                                            <DocBlueIcon className="w-2 h-2" />
                                        </div>
                                        <div className={`h4-medium w-break ${(x.Selected && IsDarkMode) ? "color-lite-dark-black" : "color-primary-accent"}`}>
                                            {x.FileName}
                                        </div>
                                        <div className="h6-medium color-con-hist-msg-date ml-auto mr-2">
                                            {IsMobileDevice ? "" : "Updated "} {UtilityService.convertDateToDay(x.updatedAt)}
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </>
                :

                <>
                    <div className='mx-auto h5-semibold d-flex align-center h-p-15 w-p-100 bb-primary-divider-2'>
                        <div className="w-6 h-6 d-flex align-center justify-center mx-2 mb-1 br-3 bg-color-vigenary">
                            <DocBlueIcon className="w-3 h-3" />
                        </div>
                        <div className="">
                            <div className="h2-semibold">
                                Review & Sign
                            </div>
                            {!IsMobileDevice && <div className="h6-medium color-con-hist-msg-date">
                                Sending to {Props.PhoneNumber}
                            </div>
                            }
                        </div>
                        <div className="d-flex ml-auto align-center mr-4">

                            <div className={`w-3 h-3 br-3 mr-1 d-flex justify-center align-center bg-color-primary-success color-secondary`}>
                                <WhiteTickIcon />
                            </div>
                            <div className={`h4-medium mr-2 color-secure-chat-login-pin`}>Select Template</div>

                            <div className={`w-3 h-3 br-3 mr-1 d-flex justify-center align-center bg-color-primary-light color-secondary`}>2</div>
                            <div className={`h4-medium color-primary-accent`}>Send</div>
                        </div>
                    </div>
                    <div className='d-flex flex-direction w-p-100 h-p-72 o-y-scroll'>
                        <div className={`h6-medium mr-2 color-secure-chat-login-pin ml-2 mb-1 mt-2`}>SELECTED TEMPLATE</div>
                        <div className={`flex-1 mx-2 min-h-8 max-h-8 br-3 page-not-found-border d-flex mb-1 align-center bg-color-con-hist-inbound-msg-bg`}>
                            <div className={`w-4 h-4 d-flex align-center justify-center mx-2 br-2 ${IsDarkMode ? "bg-color-vigenary" : "bg-color-con-hist-outbound-msg-bg"}`}>
                                <DocBlueIcon className="w-2 h-2" />
                            </div>
                            <div className="h4-medium">{selectedTemplate.FileName}</div>
                            <div className="h6-medium color-primary-light c-pointer ml-auto mr-2" onClick={() => setCurrentStep(1)}>Change</div>
                        </div>
                        <div className={`h6-medium mr-2 color-secure-chat-login-pin ml-2 my-1`}>RECIPIENT DETAILS</div>
                        <div className={`h6-medium mr-2 color-primary-accent ml-2`}>Name*</div>
                        <div className={`flex-1 mx-2 min-h-8 max-h-8 d-flex flex-direction align-center h4-medium o-hidden`}>
                            <TextField
                                className="br-3"
                                name={"RecipientName"}
                                InputProps={{ classes: { input: 'h4-regular color-primary-accent br-3' } }}
                                placeholder="Recipient name"
                                fullWidth
                                size="small"
                                autoComplete="nope"
                                value={name}
                                onChange={handleNameChange}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: "9px",
                                        '&.Mui-focused fieldset': {
                                            borderRadius: "9px",
                                        },
                                    },
                                }}
                            />
                            <FormHelperText className={`h6-regular color-primary-danger d-flex justify-between ml-auto`}>
                                {nameError}
                            </FormHelperText>
                        </div>
                        <div className={`h6-medium mr-2 color-primary-accent ml-2`}>Phone Number</div>
                        <div className={`flex-1 mx-2 min-h-6 max-h-6 br-3 page-not-found-border d-flex mb-1 align-center h5-medium o-hidden`}>
                            <div className="d-flex flex-1 ml-2 h4-medium">{Props.PhoneNumber}</div>
                            <div className="w-20 h-p-100 bg-color-con-hist-inbound-msg-bg d-flex justify-center align-center">
                                <GreyLockIcon className="mr-1" /> Auto-filled
                            </div>
                        </div>
                        <div className={`h6-medium mr-2 color-primary-accent ml-2 mt-1`}>Email Address*</div>
                        <div className={`flex-1 mx-2 min-h-8 max-h-8 d-flex flex-direction align-center h4-medium o-hidden`}>
                            <TextField
                                className="br-3"
                                name={"RecipientEmail"}
                                InputProps={{ classes: { input: 'h4-regular color-primary-accent br-3' } }}
                                placeholder="johndoe@email.com"
                                fullWidth
                                size="small"
                                autoComplete="nope"
                                value={email}
                                onChange={handleEmailChange}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: "9px",
                                        '&.Mui-focused fieldset': {
                                            borderRadius: "9px",
                                        },
                                    },
                                }}
                            />
                            <FormHelperText className={`h6-regular color-primary-danger d-flex justify-between w-p-100`}>
                                <span className="color-secure-chat-login-pin mr-auto">The recipient will receive the signing link by email.</span>{emailError}
                            </FormHelperText>
                        </div>
                        <div className={`flex-1 mx-2 min-h-6 max-h-8 br-3 b-around-consent-message-border mb-1 bg-color-vigenary  ${IsDarkMode ? "color-secure-chat-login-pin" : "color-switchUIoption"}  my-2 h5-medium p-1 d-flex align-center`}>
                            <BlueInfoIcon className="w-3 h-3 mr-1 " /><div>
                                A secure signing link will be sent to <span className="h5-semibold color-primary-light">{Props.PhoneNumber}</span> via SMS. You'll be notified in this conversation when they sign.
                            </div>
                        </div>
                    </div>
                </>
            }
            <div className='bb-primary-divider-2'></div>
            <div className='mx-auto h5-semibold d-flex align-center h-p-12'>
                {selectedTemplate?.ID && currentStep === 1 && !IsMobileDevice && <div className="d-flex ml-2">
                    <div className="h5-regular color-color-con-hist-msg-date">Selected:&nbsp; </div>
                    <div className="h5-semibold color-primary-accent"> {selectedTemplate.FileName}</div>
                </div>
                }
                {currentStep === 1 ?
                    <div className="d-flex ml-auto">
                        <ButtonComponent ButtonLabel="Cancel" Variant="secondary-btn-small" OnClick={(e) => Props.HandleClose()} ClassName="mr-2 br-3" />
                        <ButtonComponent ButtonLabel="Next" Variant="primary-btn-small" OnClick={handleNext} ClassName="mr-2 br-3" />
                    </div>
                    :
                    <div className="d-flex ml-auto">
                        <ButtonComponent ButtonLabel="Previous" Variant="secondary-btn-small" OnClick={() => setCurrentStep(1)} ClassName="mr-2 br-3" />
                        <ButtonComponent ButtonLabel="Send for E-Sign" Variant="primary-btn-small" OnClick={HandleSubmit} Loading={isLoading} ClassName="mr-2 br-3" />
                    </div>
                }
            </div>
        </div>
    )

}


export default FalkonesignPopOverComponent;